import React from "react";
import { useNavigate } from "react-router-dom";

import { Wrapper } from "src/components";
import { ContentContainer, PageHeader } from "src/components/Layouts/AppShell";
import { MoveInConditionForm } from "./Form";

export const MoveInConditionCreateScreenContainer = () => {
  const navigate = useNavigate();

  return (
    <Wrapper isAuthorizedWrapper idSelector={"wrapperContainer"}>
      <ContentContainer size="wide">
        <PageHeader
          title="Move-In Condition Form"
          onBack={() => navigate("/requests")}
        />
        <MoveInConditionForm />
      </ContentContainer>
    </Wrapper>
  );
};
